'use strict';

var React = require('react');
var context = require('./context.js');
var types = require('./types.js');

/** @deprecated No longer needed, will be removing in v12 */
function IndexFiltersManager({
  children
}) {
  const [mode, setMode] = React.useState(types.IndexFiltersMode.Default);
  const value = React.useMemo(() => ({
    mode,
    setMode
  }), [mode, setMode]);
  return /*#__PURE__*/React.createElement(context.IndexFiltersModeContext.Provider, {
    value: value
  }, children);
}

exports.IndexFiltersManager = IndexFiltersManager;
